import styled from 'styled-components';

export const Conteiner = styled.div`
  display: flex;

  width: 100%;
  padding: 20px;

  background-color: white;
  border-radius: 15px;
`;
